import { Content, PageHeaderWrapper, Input, PageHeaderTitle } from 'cdk-radial';
import styled from 'styled-components';

export const StyledDatePicker = styled.div`
  .DayPicker {
    left: calc(100% - 610px) !important;
  }
  label {
    height: 2.8em;
  }
  display: flex;
  justify-content: flex-end;
`;

export const StyledDatePickerDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 10px 10px -51px 10px;
  z-index: 10;
  top: 11px;
`;

export const StyledCustomDatePickerDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 10px 100px 0px 10px;
  z-index: 10;
  position: absolute;
  left: 78%;
`;

export const StyledTotal = styled(Content)`
  height: 14px;
  opacity: 0.7;
  color: #151b25;
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-size: 12px;
  letter-spacing: 0px;
  line-height: 1.17;
  font-weight: 400;
  letter-spacing: 0;
  display: inline;
  padding-left: 15px;
  padding-right: 5px;
  margin: 7px 3px 2px 2px;
  color: rgba(0, 0, 0, 0.7);
`;

export const StyledTotalAmounts = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  border-bottom: 1px solid rgb(223, 223, 223);
  margin-bottom: 18px;
`;

export const StyledTotalAmount = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
`;
export const StyledAmount = styled.span`
  height: 24px;
  width: 93px;
  color: #151b25;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.15px;
  display: inline;
  margin-top: 200px;
`;
export const StyledPageHeaderWrapper = styled(PageHeaderWrapper)`
  display: flex;
  margin-bottom: 12px;
  div[data-testid='page-header-title-with-buttons'] {
    border: none !important;
  }
  border-bottom: ${({ theme }) => `1px solid ${theme.color.gray[200].value}`};
`;

export const StyledPageHeaderTitle = styled(PageHeaderTitle)`
  font-family: Roboto, sans-serif;
  font-size: 1.75rem;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 1.14;
  margin: 0px;
  color: rgb(0, 0, 0);
  padding: 0.75rem 1rem;
`;

export const StyledPostingDesc = styled(Input)`
  width: 250px;
  margin: 0px 12px;
`;
export const StyledInvoiceDesc = styled.div`
  width: 400px;
  margin-bottom: 1px;
  max-width: calc(100% - 5px);
  padding: 0px;
`;

export const StyledPageHeaderWrapperForAPClerk = styled(PageHeaderWrapper)`
  display: flex;
`;

export const StyledSpan = styled.span`
  font-size: 20px;
  font-weight: 500;
  font-family: Roboto, sans-serif;
  letter-spacing: 0.15px;
  line-height: 1.4;
  color: rgb(0, 0, 0);
`;

export const StyledDiv = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  align-items: center;
  justify-content: space-between;
`;

export const StyledCIBPostingDesc = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const TotalSelectedChecksContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;
`;

export const TotalSelectedChecks = styled.p`
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: var(--text-icons-light-active-dark, #000);
  text-align: right;
`;

export const StyledPrintContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 24px;
  margin-left: 16px;
  gap: 16px;
`;

export const StyledPrintCheckValue = styled.span`
  padding: 0 20px 0 10px;
`;

export const StyledPrintCheckLabel = styled.span`
  font-family: Roboto, sans-serif;
  letter-spacing: 0.15px;
  font-size: 0.75rem;
  color: var(--text-icons-light-active-dark, #000);
  font-style: normal;
  font-weight: 500;
  margin-top: 5px;
  line-height: 14px;
`;

export const StyledPrintOrderDiv = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledTextContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledColumn = styled.div`
  display: flex;
  gap: 16px;
`;
